import React from 'react';
import { StylesProvider, createGenerateClassName, ThemeProvider } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import { Router, Switch } from 'react-router-dom';
import propTypes from 'prop-types';
import RouterRules from './router';
import theme from './theme';

const generateClassName = createGenerateClassName({ productionPrefix: 'atm-' });

const App = (props) => {
  const { activeRule } = props;
  const history = createBrowserHistory({ basename: activeRule });

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <Router history={history}>
          {/* <RouterRules /> */}
          <Switch>{RouterRules}</Switch>
        </Router>
      </ThemeProvider>
    </StylesProvider>
  );
};

App.defaultProps = {
  activeRule: '',
};

App.propTypes = {
  activeRule: propTypes.string,
};

export default App;